export const getPage = queryString => {
  const queryPageMatch = queryString.match(/page=(\d+)/)
  return queryPageMatch ? parseInt(queryPageMatch[1]) : 1
}
